<!-- Toolbar -->
<mat-toolbar class="main-toolbar">
  <!-- Left -->
  <div class="h-100 d-flex gap-2 align-items-center">
    <img
      class="h-75 cursor--pointer"
      src="/logo-wijkcollectie-ER-UMVjL.png"
      alt="logo"
      routerLink="/"
    >
    Collectiebeheer
  </div>
  <!-- End left -->
  <!-- Center -->
  <span></span>
  <!-- End center -->
  <!-- Right -->
  <div>
    <button mat-icon-button [matMenuTriggerFor]="userMenu">
      <mat-icon>person</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <!-- User name -->
      <button mat-menu-item disabled class="text-capitalize">
        {{ userInformation.name }}
      </button>
      <!-- Log out -->
      <button mat-menu-item (click)="logOut()">
        <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
        Log out
      </button>
      <!-- Version -->
      <mat-divider></mat-divider>
      <a mat-menu-item disabled>
        <mat-icon fontSet="material-symbols-outlined">commit</mat-icon>
        <span>Version:&nbsp;{{ packageService.getAppVersion() }}</span>
      </a>
    </mat-menu>
  </div>
  <!-- End right -->
</mat-toolbar>
<!-- End toolbar -->


<div class="main-content">
  <div routerLink="/story-list" routerLinkActive="d-none" [routerLinkActiveOptions]="{ exact: true }" class="breadcrumb text-muted">
    ← Terug naar overzicht
  </div>
  <div class="content-wrapper py-5 px-3">
    <router-outlet></router-outlet>
  </div>
</div>
